"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaBlock = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _context = require("../../context");
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TopAreaBlock = ({
  children
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    visible: isTopBannerVisible
  } = (0, _context.useTopAreaBanner)();
  const {
    showSearchOnScroll
  } = (0, _context.useAppConfig)();
  const isTopNavigationVisible = (0, _hooks.useIsTopAreaNavigationVisible)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TopAreaReservedSpaceBlock, {
    "data-testid": getTestId(_constants.ROOT_WRAPPER),
    id: _constants.TOP_AREA_ID,
    isTopBannerVisible: isTopBannerVisible,
    isTopNavigationVisible: isTopNavigationVisible,
    showSearchOnScroll: showSearchOnScroll,
    children: children
  });
};
exports.TopAreaBlock = TopAreaBlock;